<template>
  <v-dialog
    v-model="dialogProps.visibilidade"
    max-width="600px"
    persistent
  >
    <v-card class="pa-5">
      <!-- título -->
      <v-card-title>
        <v-row class="d-flex flex-column text-lg-center">
          <h4 class="headline primary--text text-no-wrap">
            {{ labelBtnAcao }} Experiência Profissional
          </h4>
          <span
            class="subtitle-1"
          >Informe os dados a respeito da experiência</span>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="dialogProps.valid"
        >
          <v-row>
            <!-- Cargo -->
            <v-col
              cols="12"
              md="12"
            >
              <v-autocomplete
                v-model="experienciaProfissional.tipoCargo"
                :items="listaCargos"
                :rules="[(v) => !!v || 'Selecione um cargo']"
                :search-input.sync="cargoSearch"
                item-text="nome"
                label="Cargo"
                placeholder="Digite para pesquisar..."
                persistent-hint
                prepend-icon="engineering"
                required
                return-object
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        O cargo
                        <strong
                          class="secondary--text"
                        >{{ cargoSearch }}
                        </strong>
                        não foi encontrado.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- se cargo outros, nome de outro cargo -->
            <v-col
              v-if="
                experienciaProfissional.tipoCargo &&
                  experienciaProfissional.tipoCargo.isOutro
              "
              cols="12"
            >
              <v-text-field
                v-model.trim="experienciaProfissional.nomeCargoOutro"
                :rules="ruleNotEmpty"
                label="Nome do Cargo"
                prepend-icon="library_books"
                required
              />
            </v-col>
          </v-row>

          <v-row>
            <!-- Setor -->
            <v-col
              cols="12"
              md="12"
            >
              <v-autocomplete
                v-model="experienciaProfissional.tipoSetor"
                :items="listaSetores"
                :rules="[(v) => !!v || 'Selecione um setor']"
                :search-input.sync="tipoSetorSearch"
                item-text="nome"
                label="Setor"
                placeholder="Digite para pesquisar..."
                persistent-hint
                prepend-icon="lan"
                required
                return-object
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        O setor
                        <strong
                          class="secondary--text"
                        >{{ tipoSetorSearch }}
                        </strong>
                        não foi encontrado.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- se setor outros, nome de outro setor -->
            <v-col
              v-if="
                experienciaProfissional.tipoSetor &&
                  experienciaProfissional.tipoSetor.isOutro
              "
              cols="12"
            >
              <v-text-field
                v-model.trim="experienciaProfissional.nomeSetorOutro"
                :rules="ruleNotEmpty"
                label="Nome do Setor"
                prepend-icon="library_books"
                required
              />
            </v-col>
          </v-row>

          <v-row>
            <!-- Instituição -->
            <v-col cols="12">
              <v-text-field
                v-model.trim="experienciaProfissional.instituicao"
                :rules="[(v) => !!v || 'Seleciona a instituição']"
                label="Instituição"
                prepend-icon="account_balance"
                required
              />
            </v-col>
          </v-row>

          <v-row>
            <!-- Vínculo -->
            <v-col
              cols="12"
              md="12"
            >
              <v-autocomplete
                v-model="experienciaProfissional.tipoVinculo"
                :items="listaVinculos"
                :rules="[(v) => !!v || 'Selecione um vínculo']"
                :search-input.sync="vinculoSearch"
                item-text="nome"
                label="Vínculo"
                placeholder="Digite para pesquisar..."
                persistent-hint
                prepend-icon="diversity_3"
                required
                return-object
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        O vínculo
                        <strong
                          class="secondary--text"
                        >{{ vinculoSearch }}
                        </strong>
                        não foi encontrado.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- se vínculo outros, nome de outro vínculo -->
            <v-col
              v-if="
                experienciaProfissional.tipoVinculo &&
                  experienciaProfissional.tipoVinculo.isOutro
              "
              cols="12"
            >
              <v-text-field
                v-model.trim="experienciaProfissional.nomeVinculoOutro"
                :rules="ruleNotEmpty"
                label="Nome do Vínculo"
                prepend-icon="library_books"
                required
              />
            </v-col>
          </v-row>

          <v-row>
            <!-- Função Gratificada  -->
            <v-col
              cols="12"
              md="12"
            >
              <v-autocomplete
                v-model="experienciaProfissional.tipoFuncao"
                :items="listaFuncoes"
                :rules="[(v) => !!v || 'Selecione uma função']"
                :search-input.sync="funcaoSearch"
                item-text="nome"
                label="Função Gratificada"
                placeholder="Digite para pesquisar..."
                persistent-hint
                prepend-icon="badge"
                required
                return-object
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        A função
                        <strong
                          class="secondary--text"
                        >{{ funcaoSearch }}
                        </strong>
                        não foi encontrada.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- se funcao outros, nome de outra função -->
            <v-col
              v-if="
                experienciaProfissional.tipoFuncao &&
                  experienciaProfissional.tipoFuncao.isOutro
              "
              cols="12"
            >
              <v-text-field
                v-model.trim="experienciaProfissional.nomeFuncaoOutro"
                :rules="ruleNotEmpty"
                label="Nome da Função"
                prepend-icon="library_books"
                required
              />
            </v-col>
          </v-row>

          <v-row>
            <!-- Nível da Gratificação -->
            <v-col
              v-if="
                experienciaProfissional.tipoFuncao &&
                  experienciaProfissional.tipoFuncao.isTemNivelGratificacao
              "
              cols="12"
              md="12"
            >
              <v-autocomplete
                v-model="experienciaProfissional.tipoNivelGratificacao"
                :items="listaNiveisGratificacoes"
                :rules="[(v) => !!v || 'Selecione um nível de gratificação']"
                :search-input.sync="nivelGratificacaoSearch"
                item-text="nome"
                label="Nível da Gratificação"
                placeholder="Digite para pesquisar..."
                persistent-hint
                prepend-icon="workspace_premium"
                required
                return-object
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        O nível de gratificação
                        <strong
                          class="secondary--text"
                        >{{ nivelGratificacaoSearch }}
                        </strong>
                        não foi encontrado.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- se nível de gratificação outros, nome de outro nível de gratificação -->
            <v-col
              v-if="
                experienciaProfissional.tipoNivelGratificacao &&
                  experienciaProfissional.tipoNivelGratificacao.isOutro
              "
              cols="12"
            >
              <v-text-field
                v-model.trim="
                  experienciaProfissional.nomeNivelGratificacaoOutro
                "
                :rules="ruleNotEmpty"
                label="Nome do Nível de Gratificação"
                prepend-icon="library_books"
                required
              />
            </v-col>
          </v-row>

          <v-row>
            <!-- Situação -->
            <v-col cols="12">
              <h4>Situação da Experiência Profissional</h4>
              <v-radio-group
                v-model="experienciaProfissional.status.id"
                :rules="[(v) => !!v || 'Seleciona o status']"
                required
                row
              >
                <v-radio
                  v-for="status in statusExperienciaProfissional"
                  :key="status.id"
                  :label="status.text"
                  :value="status.id"
                  required
                />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <!-- Início -->
            <v-col
              cols="12"
              md="6"
            >
              <app-date-select
                tipo="month"
                label="Início"
                tooltip="Data de início da experiência profissional"
                :data-inicial="experienciaProfissional.inicio"
                :min="minInicioExperienciaProfissional"
                :max="maxInicioExperienciaProfissional"
                @return="(value) => (experienciaProfissional.inicio = value)"
              />
            </v-col>

            <!-- Término -->
            <v-col
              v-if="!statusAtualExperiencia"
              cols="12"
              md="6"
            >
              <app-date-select
                tipo="month"
                label="Término"
                tooltip="Data de término da experiência profissional"
                :data-inicial="experienciaProfissional.termino"
                :min="minTerminoExperienciaProfissional"
                :max="maxTerminoExperienciaProfissional"
                @return="(value) => (experienciaProfissional.termino = value)"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <!-- Ações -->
      <v-card-actions>
        <v-row class="justify-end mr-4">
          <v-btn
            :disabled="!dialogProps.valid"
            class="mr-2"
            color="primary"
            @click="doAcao"
          >
            {{ labelBtnAcao }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            @click="dialogProps.visibilidade = false"
          >
            Cancelar
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { mapState } from 'vuex';
import AppDateSelect from '@/components/core/AppDateSelect';
import Data from '@/modules/data';

const experienciaProfissionalRepository = RepositoryFactory.get('experienciaProfissional');

const DEFAULT_EXPERIENCIA_PROFISSIONAL = () => ({
  id: null,
  tipoSetor: null,
  nomeSetorOutro: null,
  instituicao: null,
  tipoVinculo: null,
  nomeVinculoOutro: null,
  tipoCargo: null,
  nomeCargoOutro: null,
  tipoFuncao: null,
  nomeFuncaoOutro: null,
  tipoNivelGratificacao: null,
  nomeNivelGratificacaoOutro: null,
  status: { id: null },
  inicio: null,
  termino: null,
});

export default {
  name: 'DialogExperienciaProfissional',

  components: { AppDateSelect },

  props: {
    dialogProps: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      ruleNotEmpty: [(v) => (v && !!v.trim()) || 'Campo Obrigatório'],
      experienciaProfissional: DEFAULT_EXPERIENCIA_PROFISSIONAL(),
      tipoSetorSearch: '',
      vinculoSearch: '',
      cargoSearch: '',
      funcaoSearch: '',
      nivelGratificacaoSearch: '',
      statusExperienciaProfissional: [
        { id: 'ATUAL', text: 'Atual' },
        { id: 'CONCLUIDA', text: 'Concluída' },
      ],
      dataAtual: Data.get('YYYY-MM-DD'),
    };
  },

  computed: {
    ...mapState({
      perfil: (state) => state.auth.usuario.perfil,
      listaSetores: (state) => state.perfil.listaSetores,
      listaVinculos: (state) => state.perfil.listaVinculos,
      listaCargos: (state) => state.perfil.listaCargos,
      listaFuncoes: (state) => state.perfil.listaFuncoes,
      listaNiveisGratificacoes: (state) => state.perfil.listaNiveisGratificacoes,
    }),

    labelBtnAcao() {
      if (this.dialogProps.acao === 'editar') {
        return 'Editar';
      }
      if (this.dialogProps.acao === 'cadastrar') {
        return 'Adicionar';
      }
      return null;
    },
    minInicioExperienciaProfissional() {
      return '';
    },
    maxInicioExperienciaProfissional() {
      return this.experienciaProfissional.termino == null ? this.dataAtual : this.experienciaProfissional.termino;
    },
    minTerminoExperienciaProfissional() {
      return this.experienciaProfissional.inicio;
    },
    maxTerminoExperienciaProfissional() {
      return this.dataAtual;
    },
    statusAtualExperiencia() {
      return this.experienciaProfissional.status && this.experienciaProfissional.status.id === 'ATUAL';
    },
    nivelGratificacaoSemGratificacao() {
      return this.listaNiveisGratificacoes.find((n) => n.nome === 'Sem Gratificação');
    },
  },

  watch: {
    'dialogProps.visibilidade': function (visibilidade) {
      if (visibilidade) {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        if (this.dialogProps.acao === 'editar') {
          // deep copy
          this.experienciaProfissional = JSON.parse(JSON.stringify(this.dialogProps.experienciaProfissional));
        }
        if (this.dialogProps.acao === 'cadastrar') {
          this.experienciaProfissional = DEFAULT_EXPERIENCIA_PROFISSIONAL();
        }
      } else {
        this.experienciaProfissional = DEFAULT_EXPERIENCIA_PROFISSIONAL();
      }
    },
    'experienciaProfissional.tipoFuncao': function () {
      if (this.experienciaProfissional.tipoNivelGratificacao === null) {
        this.experienciaProfissional.tipoNivelGratificacao = this.nivelGratificacaoSemGratificacao;
      }
    },
  },

  methods: {
    doAcao() {
      this.experienciaProfissional.inicio = Data.create(this.experienciaProfissional.inicio)
        .startOf('month')
        .format('YYYY-MM-DD');
      if (this.statusAtualExperiencia) {
        this.experienciaProfissional.termino = null;
      } else {
        this.experienciaProfissional.termino = Data.create(this.experienciaProfissional.termino)
          .endOf('month')
          .format('YYYY-MM-DD');
      }

      if (this.dialogProps.acao === 'editar') {
        experienciaProfissionalRepository.update(this.experienciaProfissional).then((res) => {
          const experiencia = res.data;
          if (experiencia.id) {
            const index = this.perfil.experienciasProfissionais.findIndex((e) => e.id === experiencia.id);
            if (index !== -1) {
              this.perfil.experienciasProfissionais.splice(index, 1, experiencia);
              this.dialogProps.visibilidade = false;
              this.$store.dispatch('app/success', {
                response: res,
                message: 'Experiência profissional editada com sucesso!',
              });
            }
          }
        });
      }

      if (this.dialogProps.acao === 'cadastrar') {
        experienciaProfissionalRepository.create(this.experienciaProfissional).then((res) => {
          this.perfil.experienciasProfissionais.push(res.data);
          this.perfil.experienciasProfissionais.sort((a, b) => {
            if (a.inicio > b.inicio) {
              return 1;
            }
            if (a.inicio < b.inicio) {
              return -1;
            }
            return 0;
          });
          this.dialogProps.visibilidade = false;
          this.$store.dispatch('app/success', {
            response: res,
            message: 'Experiência profissional cadastrada com sucesso!',
          });
        });
      }
    },
  },
};
</script>
